const updates = [
  { id: 1, date: '2026-07-30', title: '《鬼灭之刃 无限城篇》最新话已更新', tag: '日漫更新' },
  { id: 2, date: '2026-07-29', title: '《斗破苍穹》年番第156集上线', tag: '国漫更新' },
  { id: 3, date: '2026-07-29', title: '下载线路全面升级，速度提升300%', tag: '平台公告' },
  { id: 4, date: '2026-07-28', title: '《我推的孩子》第二季第8集已更新', tag: '日漫更新' },
  { id: 5, date: '2026-07-28', title: '《完美世界》第198集高清版上线', tag: '国漫更新' },
  { id: 6, date: '2026-07-27', title: '七月新番专题页面上线，一站式追番体验', tag: '功能更新' },
  { id: 7, date: '2026-07-27', title: '《葬送的芙莉莲》第二季预告PV已收录', tag: '资讯速递' },
  { id: 8, date: '2026-07-26', title: '《凡人修仙传》第五季第12集更新', tag: '国漫更新' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            更新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            最新的番剧更新和平台动态，追番快人一步
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {updates.map((update, idx) => (
            <div
              key={update.id}
              className="flex items-start gap-3 md:gap-4 pb-5 mb-5 border-b border-background-200/40 last:border-0 last:mb-0 last:pb-0"
            >
              <div className="relative flex flex-col items-center shrink-0">
                <div className={`w-2.5 h-2.5 rounded-full mt-1.5 ${idx === 0 ? 'bg-accent-500 ring-4 ring-accent-100' : 'bg-background-300'}`}></div>
                {idx < updates.length - 1 && <div className="w-px h-full bg-background-200 absolute top-4"></div>}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {update.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{update.date}</span>
                </div>
                <div className="text-sm md:text-base text-foreground-800 font-medium">{update.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}